/**
 * The human escape hatch. Every client-facing dead end (404, replaced link,
 * load failure) and the page footer point at Henry directly — the brand
 * promise is "you work directly with Henry", so when something breaks he
 * has to be one tap away.
 */

export const CONTACT_EMAIL = 'henry@henrysheahanproductions.com';

export default function ContactLine({ className = '' }: { className?: string }) {
  return (
    <p className={`text-[13px] text-muted leading-[1.55] ${className}`}>
      Stuck or unsure? Email Henry at{' '}
      <a
        href={`mailto:${CONTACT_EMAIL}`}
        className="text-accent underline underline-offset-2 hover:opacity-80 transition-opacity"
      >
        {CONTACT_EMAIL}
      </a>
    </p>
  );
}
